var map = {
	"./Ami-Logo.png": 5770,
	"./Ami-Nav.png": 5199,
	"./Footer.png": 6349,
	"./Functionality-1.png": 7825,
	"./Functionality-2.png": 3928,
	"./Functionality-Calendar.png": 8867,
	"./Functionality-Cooking.png": 5802,
	"./Functionality-DIY.png": 3655,
	"./Functionality-Download.png": 421,
	"./Functionality-Image.png": 2989,
	"./Functionality-Map.png": 6238,
	"./Functionality-Photo.png": 9741,
	"./Functionality-Shopping.png": 5597,
	"./Functionality-Text-1.png": 6160,
	"./Functionality-Text-2.png": 9135,
	"./HomeHeader.png": 9623,
	"./HomePageBG.png": 3589,
	"./NavBG.png": 3224,
	"./Phone.png": 9191,
	"./Question.png": 7087,
	"./SpeechBubbleMan.png": 1916,
	"./Team-1.png": 8921,
	"./Team-2.png": 9956,
	"./Team-3.png": 6338,
	"./Team-4.png": 2428,
	"./Team-5.png": 5363,
	"./Team-6.png": 4180,
	"./User-Coffee.png": 4269,
	"./User-PlantLover.png": 8308,
	"./User-Vegan.png": 9303,
	"./UserPersona-1.svg": 18,
	"./UserPersona-2.svg": 2725,
	"./VoiceAssistant.svg": 7715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4480;